function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerBusinessMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.675 16.5H5.325C4.05 16.5 3 15.4575 3 14.175V3.825C3 2.55 4.0425 1.5 5.325 1.5H12.675C13.95 1.5 15 2.5425 15 3.825V14.175C15 15.4575 13.9575 16.5 12.675 16.5Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.75H4.125C3.5025 9.75 3 9.2475 3 8.625V7.125C3 6.5025 3.5025 6 4.125 6H13.875C14.4975 6 15 6.5025 15 7.125V8.625C15 9.2475 14.4975 9.75 13.875 9.75Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37088 13.275H6.37762",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6209 13.275H11.6276",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 3.75H10.875",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerBusinessMobileNav);
export default __webpack_public_path__ + "static/media/customer-business-mobile-nav.5ff5b8aa52593dfca97f88c3e4b10eed.svg";
export { ForwardRef as ReactComponent };